import * as M from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';

import { InfoField } from '../../../../../../ui/infoField/InfoField';

import type { KeyboardEvent } from 'react';
import type { IAiAgentTemplateFilterForm } from '../types';

interface IAiAgentAsTemplateFilterSectionProps {
  filterForm: IAiAgentTemplateFilterForm;
  onChangeFilterForm: (nextFilter: Partial<IAiAgentTemplateFilterForm>) => void;
  onSearch: () => void;
  onReset: () => void;
}

export default function AiAgentAsTemplateFilterSection(props: IAiAgentAsTemplateFilterSectionProps) {
  const { filterForm, onChangeFilterForm, onSearch, onReset } = props;

  return (
    <M.Box
      style={{
        borderTop: '1px solid var(--mantine-color-gray-3)',
        borderLeft: '1px solid var(--mantine-color-gray-3)',
      }}
    >
      <M.SimpleGrid cols={2} spacing={0} verticalSpacing={0} style={{ gridTemplateColumns: '180px minmax(0, 1fr)' }}>
        <InfoField label="기간" labelAlign="left" contentAlign="left">
          <M.Flex gap="xs" align="center" wrap="wrap">
            <DatePickerInput
              leftSection={<IconCalendar size={14} />}
              placeholder="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              w={210}
              value={filterForm.startDate}
              onChange={(date) => onChangeFilterForm({ startDate: date })}
            />
            <M.Text c="gray.7">-</M.Text>
            <DatePickerInput
              leftSection={<IconCalendar size={14} />}
              placeholder="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              w={210}
              value={filterForm.endDate}
              onChange={(date) => onChangeFilterForm({ endDate: date })}
            />
          </M.Flex>
        </InfoField>
        <InfoField label="상세 검색" labelAlign="left" contentAlign="left">
          <M.Flex gap="sm" align="center" wrap="wrap" w="100%">
            <M.TextInput
              w={400}
              placeholder="템플릿명으로 검색"
              value={filterForm.keyword}
              onChange={(event) => onChangeFilterForm({ keyword: event.currentTarget.value })}
              onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
                if (event.key === 'Enter') {
                  onSearch();
                }
              }}
            />
            <M.Button variant="filled" color="primary.5" onClick={onSearch}>
              조회
            </M.Button>
            <M.Button variant="default" onClick={onReset}>
              초기화
            </M.Button>
          </M.Flex>
        </InfoField>
      </M.SimpleGrid>
    </M.Box>
  );
}
